<template>
<div id="cloud">
<h1> Word cloud from database </h1>
<div v-if="progress">
  Progress <progress-bar :options=options :value="Math.round(progress.completedWords / progress.totalWords * 100)" />
</div>
<br />
<br />
<vue-word-cloud
  :progress.sync="progress"
  style="
    height: 960px;
    width: 640px;
    margin-left: auto;
    margin-right: auto;
  "
  :animation-duration="parseInt(1500)"
  :spacing="0.55"
  :animation-overlap="parseInt(3)"
  :words="ws">
<template slot-scope="{ text, weight, word }">
        <div :title="weight" style="cursor: pointer" @click="onWordClick(word)">
          {{ text }}
        </div>
      </template>
</vue-word-cloud>
<br />
<br />
<v-btn @click="reload_one" color="success"> Reload word cloud </v-btn>
<br />
<br />
<br />
<br />
<br />
</div>
</template>

<script>
export default {
  name: 'WordCloudView',
  computed: {
    installed_fontfaces () {
      return ['Purisa']
      // return ['Merienda', 'Quattrocento', 'Open Sans', 'Roboto']
    }
  },
  props: {
    query_data: Object
  },
  data () {
    return {
      ws: [],
      data: this.query_data,
      progress: undefined,
      options: {
        text: {
          color: '#FFFFFF',
          shadowEnable: true,
          shadowColor: '#000000',
          fontSize: 14,
          fontFamily: 'Helvetica',
          dynamicPosition: false,
          hideText: false
        },
        progress: {
          color: '#2dbd2d',
          backgroundColor: '#333333',
          inverted: false
        },
        layout: {
          height: 35,
          width: 140,
          verticalTextAlign: 61,
          horizontalTextAlign: 43,
          zeroOffset: 0,
          strokeWidth: 30,
          progressPadding: 0,
          type: 'circle'
        }
      }
    }
  },
  methods: {
    onWordClick (text) {
      alert(text.text)
    },
    reload_one () {
      const n = Math.floor(Math.random() * this.ws.length)
      var o = this.ws[n]
      const stdRot = this.std_rotations()
      const col = this.random_color()

      // o['weight'] = w
      o['rotation'] = stdRot
      // o['fontWeight'] = w
      o['color'] = col
      this.ws[n] = o
    },
    findOcc (arr, key) {
      let arr2 = []
      arr.forEach((x) => {
        if (arr2.some((val) => { return val[key] === x[key] })) {
          arr2.forEach((k) => {
            if (k[key] === x[key]) {
              k['occurrence']++
            }
          })
        } else {
          let a = {}
          a[key] = x[key]
          a['occurrence'] = 1
          arr2.push(a)
        }
      })
      return arr2
    },

    create_words () {
      var occByName = this.findOcc(this.query_data, 'name')
      var occByTissue = this.findOcc(this.query_data, 'tissue')
      var occByTitle = this.findOcc(this.query_data, 'title')
      var occByExperiment = this.findOcc(this.query_data, 'experiment')
      var authors = occByName.map(function (e) {
        return [e['name'], e['occurrence']]
      })
      var tissues = occByTissue.map(function (e) {
        return [e['tissue'], e['occurrence']]
      })
      var titles = occByTitle.map(function (e) {
        return [e['title'], e['occurrence']]
      })
      var experiments = occByExperiment.map(function (e) {
        return [e['experiment'], e['occurrence']]
      })
      return authors.concat(tissues).concat(titles).concat(experiments)
    },
    random_fontface () {
      return this.installed_fontfaces[Math.floor(Math.random() * this.installed_fontfaces.length)]
    },
    random_color () {
      const colorPalette = [
        '#e27d60',
        '#85dcb0',
        '#e8a87c',
        '#c38d9e',
        '#41b3a3'
      ]

      return colorPalette[Math.floor(Math.random() * colorPalette.length)]
    },
    std_rotations () {
      const rotations = [0, 0, 90, -90]
      return rotations[Math.floor(Math.random() * rotations.length)]
    }
  },
  created () {
    var words = this.create_words()
    const r = words.map((e) => {
      const fontFace = this.random_fontface()
      const stdRot = this.std_rotations()
      const col = this.random_color()
      return {
        text: e[0],
        weight: 2 * e[1],
        rotation: stdRot,
        rotationUnit: 'deg',
        fontFamily: fontFace,
        fontStyle: '',
        fontVariant: '',
        fontWeight: e[1],
        color: col
      }
    })

    this.ws = r
  }
}
</script>

<style scoped>
#cloud {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-right: auto;
  margin-left: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/WordCloudView.vue